define.alias("shared/components/shared/color-picker/header", "media/components/shared/color-picker/header");